/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MenuItem/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function MenuItem({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Tabs/Content/MenuItem"
  
}) {
let tabSelectedBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_id',
})
let menuItemIdValueData = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'id',
})
let aggregateData = fromHelpers.isDisabled(tabSelectedBoardIdValueData, menuItemIdValueData)
let menuItemTextValueData = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'text',
})
let tabSelectedBoardSubmenuTabIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_submenu_tab_id',
})
let menuItemIdValueData1 = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'id',
})
let aggregateData1 = fromAggregate.equals(tabSelectedBoardSubmenuTabIdValueData, menuItemIdValueData1)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 data="tab.selected.board_id"
 data="menu_item.id"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
 data="menu_item.text"
 text={menuItemTextValueData}
 onClick={onClick}
 data="tab.selected.board_submenu_tab_id"
 data="menu_item.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
/>
{children}
</React.Fragment>)
}